import { render, staticRenderFns } from "./DoorImpacts.vue?vue&type=template&id=b3d035ce&scoped=true"
import script from "./DoorImpacts.vue?vue&type=script&lang=ts"
export * from "./DoorImpacts.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3d035ce",
  null
  
)

export default component.exports